export default __webpack_public_path__ + "static/media/LogoVaisand.f7f722f0.svg";